import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_ItemService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String,id:number): Observable<Array<PM_Itme_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMItem?token=" + Token+"&id="+id).pipe(
      map(data => {
        return data as Array<PM_Itme_Interface>
      })
    )
  }

  GetActive(Token: String,id:number): Observable<Array<PM_Itme_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMItem/GetActive?token=" + Token+"&id="+id).pipe(
      map(data => {
        return data as Array<PM_Itme_Interface>
      })
    )
  }

  AddEditPM(
    model: PM_Itme_Interface,
    Token: String): Observable<PM_Itme_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var modelCustomer = {
      id: model.id,
      title: model.title,
      parent: model.parent,
      icon: model.icon,
      del: model.del,
    }

    var body = {
      model: modelCustomer,
      token: Token
    }


    return this.http.post(environment.BaseUrl + "Daro/PMItem/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as PM_Itme_Interface
      })
    )

  }




  DeletePM(id: number, Token: String): Observable<PM_Itme_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/PMItem/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as PM_Itme_Interface
      })
    )

  }

}
